import { render, staticRenderFns } from "./CostBearers.vue?vue&type=template&id=59d371f8&"
import script from "./CostBearers.vue?vue&type=script&lang=ts&"
export * from "./CostBearers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports